import { WebPlugin } from "@capacitor/core";
export class CapacitorGoogleMapsWeb extends WebPlugin {
    constructor() {
        super({
            name: "CapacitorGoogleMaps",
            platforms: ["web"],
        });
    }
    async initialize(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async createMap(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async removeMap(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async clearMap(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async updateMap(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async moveCamera(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async addMarker(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async removeMarker(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didTapInfoWindow(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didCloseInfoWindow(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didTapMap(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didLongPressMap(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didTapMarker(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didBeginDraggingMarker(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didDragMarker(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didEndDraggingMarker(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didTapMyLocationButton(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didTapMyLocationDot(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didTapPoi(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didBeginMovingCamera(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didMoveCamera(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async didEndMovingCamera(_options, _callback) {
        throw this.unimplemented("Not implemented on web.");
    }
    async elementFromPointResult(_options) {
        throw this.unimplemented("Not implemented on web.");
    }
}
